7<template>
  <div class="education">
    <div class="qrCode">
      <a class="title" href=""><i></i><span style="position:relative;top:-6px;">微信公众号</span></a>
      <swiper>
        <swiper-slide v-for="(slideItem, slideIndex) in qrCodeArr" :key="slideIndex" class="ulSlide" ref="qrcode">
          <li v-for="(item, index) in slideItem" :key="index">
            <div class="imgBox"><p class="imgContent"  v-show="item.imgUrl"><img :src="item.imgUrl" alt=""></p></div>
            <div class="infoBox">
              <span class="infoName">{{ item.name }}</span>
              <span class="infoIntro">{{ item.intro }}</span>
            </div>
          </li>
        </swiper-slide>
      </swiper>
    </div>
    <div class="application qrCode">
      <a class="title" href=""><i></i><span style="position:relative;top:-6px;">应用新秀</span></a>
      <swiper>
        <swiper-slide v-for="(slideItem, slideIndex) in applicationsArr" :key="slideIndex" class="ulSlide" ref="applications">
          <a v-for="(item, index) in slideItem" :key="index" :href="item.url">
            <li :href="item.url">
              <div class="imgBox"><p class="imgContent"  v-show="item.imgUrl"><img :src="item.imgUrl" alt=""></p></div>
              <div class="infoBox">
                <span class="infoName" style="color: #333;">{{ item.name }}</span>
                <span class="infoIntro">{{ item.intro }}</span>
              </div>
            </li>
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { qrcode } from 'js/home/qrcode.js'
import { applications } from 'js/home/applications.js'
export default {
  name: 'qrCode',
  data () {
    return {
      qrcode,
      applications
    }
  },
  mounted () {},
  computed: {
    qrCodeArr () {
      let arr = []
      let len = Math.ceil(qrcode.length / 3)
      for (let i = 0; i < len; i++) {
        for (let j = i * 3; j < (i + 1) * 3; j++) {
          if (!arr[i]) {
            arr[i] = []
          }
          if (!qrcode[j]) {
            qrcode[j] = {}
          }
          arr[i].push(qrcode[j])
        }
      }
      return arr
    },
    applicationsArr(){
      let arr = []
      let len = Math.ceil(applications.length / 4)
      for (let i = 0; i < len; i++) {
        for (let j = i * 4; j < (i + 1) * 4; j++) {
          if (!arr[i]) {
            arr[i] = []
          }
          if (!applications[j]) {
            applications[j] = {}
          }
          arr[i].push(applications[j])
        }
      }
      return arr
    }
  },
  swiper () {
    return this.$refs.qrcode.swiper
    return this.$refs.qrcode.applications
  }
}
</script>

<style lang="stylus" scoped>
.education
  float: right
  width: 250px
  height: 730px
  // display: flex
  // flex-direction: column
  border-left: 1px solid #eee;
  .qrCode
    flex: 3
    display: flex
    flex-direction: column
    .title
      position: relative;
      left: -1px;
      margin-bottom: 10px
      display: inline-block
      height: 36px
      width: 100%
      color: #333
      font-size: 18px
      line-height: 36px
      i
        display: block
        width: 4px
        height: 20px
        float: left
        margin-right: 10px
        position: relative
        top: 50%
        margin-top: -17px
        background: #38bca4
    .swiper-container
      width: 250px
      position: relative
      top: -6px
      // height: 326px
      .swiper-slide
        display: flex;
        flex-direction: column
        li
          flex: 1
          display: flex
          padding: 13px 0 13px 12px
          width:250px\9\0
          height:70px\9\0
          clear :both\9\0
          zoom :1\9\0
          display: block\9\0
          .imgBox
            // flex: 1
            width: 76px
            height: 60px
            width: 83px\9\0;
            height: 76px\9\0;
            .imgContent
              width: 60px
              height: 60px
              border-radius: 10px;
              position: relative
              border: 1px solid #eee
              // top: 50%
              // margin: -28px auto 0
              overflow: hidden
              // text-align: center
              img
                width: 60px
                height :60px
          .infoBox
            flex: 2
            display: flex
            flex-direction: column
            .infoName
              margin-top:10px;
              // flex: 1
              // line-height: 33px
              font-size: 14px;
            .infoIntro
              // flex: 1
              margin-top:12px
              // line-height: 30px
              color: #8e8e8e
  .application
    flex: 4
    display: flex
    flex-direction: column
    margin-top: 40px;
    h3
      height: 36px
      width: 100%
      color: #333
      font-size: 18px
      line-height: 36px
      i
        display: block
        width: 4px
        height: 24px
        float: left
        margin-right: 10px
        position: relative
        top: 50%
        margin-top: -12px
        background: #38bca4
    ul
      display: flex
      flex: 1
      flex-direction: column
      li
        flex: 1
        display: flex
        padding: 16px 0
        .imgBox
          flex: 1
          .imgContent
            border-radius: 16px
            width: 60px
            height: 60px
            position: relative
            top: 50%
            margin: -30px auto 0
            overflow: hidden
            text-align: center
            img
              width: 100%
              height: 100%
        .infoBox
          display: flex
          flex: 2
          font-size: 11px
          padding: 10px 0
          flex-direction: column
          .infoName
            flex: 2
            display:flex
            font-size: 13px
            line-height: 20px
          .infoIntro
            display: flex
            flex: 3
            height: 28px
            line-height: 28px
            overflow: hidden
            color: #8e8e8e
            width:100%\9\0
            display: block\9\0
</style>



// WEBPACK FOOTER //
// src/common-components/QRCode.vue